import openClose from "@/OpenClose.vue"
import Issues from "@/issues/Issues.vue"
import MetadataList from "@/browse/MetadataList.vue"
import 'src/styles/taggle.css'
import 'src/styles/aristotle.less'
import apolloProvider from 'src/lib/graphql/vue-apollo'
import router from 'src/router/router'

export default {
    el: '#vue-container',
    apolloProvider,
    router,
    components: {
        'open-close': openClose,
        'issues': Issues,
        MetadataList
    },
}
